// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	angular.module("swurveys.maker")
		.controller("adminController", Handler)

	function Handler($scope, $window, $location, analyticsService, swurveyAdminService, ModalService, loggedInUser, $routeParams) {
		//Fields --------------------------------------------------------------

		/**
		 * Refreshes swurvey list. Called after deleting/publishing swurvey
		 */
		var refreshUserList = function () {

			swurveyAdminService.listUsers(function (err, data) {
				if(err) {
					console.error(err);
					$window.location.reload();
					$window.location.assign("/designer.html#/l");
				}
				$scope.users = data.users;
				console.log(data);
			});
		};

		$scope.urlBuilder = {
			mediums : {
				Social : { Name : "Social", Sources : ["Facebook", "Twitter", "LinkedIn"]},
				Email : {Name: "Email", Sources: ["LinkedIn", "Newsletter", "DripMarketing"]},
			}
		};

		$scope.searchText = $routeParams.search;



		$scope.redirectToReport = function(date) {
			var url = swurveyAdminService.getReportURL("getAnalyticsLeaderboard", date);

			$window.open(url, '_blank');

		};

		$scope.toggleUserType = function(user, type)
		{
			console.log(user.UserId, type);
			if(!user.userType)
			{
				user.userType = [];
			}
			var idx =  user.userType.indexOf(type);
			if(idx > -1)
			{
				//Remove this type
				delete user.userType[idx];
			}
			else {
				user.userType.push(type);
			}
			user.updating = true;
			user.updatedSuccess = false;
			user.updatedFail = false;
			swurveyAdminService.updateUser(user.UserId, { userType : user.userType }, function(err, data){
				console.log(err, data);
				if(err)
				{
					user.updatedFail = true;
				}
				else
				{
			      user.updatedSuccess = true;
				}
			    user.updating = false;
			    user = data;
			});
		};

		$scope.updateAccountBalance = function(user)
		{
			user.updating = true;
			swurveyAdminService.updateUser(user.UserId, { accountBalance: user.accountBalance }, function(err, data){
				user.updating = false;
				user.updatedSuccess = true;
				user = data;
			});
		};

		$scope.updateAutoTopUpAmount = function(user)
		{
			user.updating = true;
			swurveyAdminService.updateUser(user.UserId, { autoTopUpCreditAmount: user.autoTopUpCreditAmount }, function(err, data){
				user.updating = false;
				user.updatedSuccess = true;
				user = data;
			});
		};

		$scope.updateAutoTopUpThreshold = function(user)
		{

			user.updating = true;
			swurveyAdminService.updateUser(user.UserId, { autoTopUpCreditThreshold: user.autoTopUpCreditThreshold }, function(err, data){
				user.updating = false;
				user.updatedSuccess = true;
				user = data;
			});
		};

		$scope.updateComment = function(user)
		{

			user.updating = true;
			swurveyAdminService.updateUser(user.UserId, { comment: user.comment }, function(err, data){
				user.updating = false;
				user.updatedSuccess = true;
				user = data;
			});
		};

		refreshUserList();

		analyticsService.trackEvent('ViewAdminDashboard');

	}
}());
